import { render } from "./Layout.vue?vue&type=template&id=354f7f8e&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=354f7f8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-354f7f8e"

export default script